export const SET_ERROR = "error/set_error"
export const CLEAR_ERROR = "error/clear_error"
